import CartProducts from './CartProducts';

export default CartProducts;


// WEBPACK FOOTER //
// ./src/components/CartProducts/index.tsx